// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"5290a238","416":"9903c0ef","538":"7502cfce","545":"363a01e3","566":"8ac7cd68","614":"084c75c7","642":"53c7d28c","676":"0726e418","768":"6299f210","859":"4ece1067"}[chunkId] + ".chunk.js";
};